import { Component, OnInit, signal, OnDestroy, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { ToastService, Toast } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts = signal<Toast[]>([]);
  private timeouts = new Map<string, NodeJS.Timeout>();
  private subscription: Subscription | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.subscription = this.toastService.toast$.subscribe((toast: Toast) => {
      if (toast) {
        this.addToast(toast);
      }
    });
  }

  ngOnDestroy() {
    // Clear all timeouts on destroy
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  addToast(toast: Toast) {
    const id = `${Date.now()}-${Math.random()}`;
    const toastWithId: Toast = { ...toast, id };
    
    this.toasts.set([...this.toasts(), toastWithId]);

    // Auto remove after duration (default 4 seconds)
    const timeout = setTimeout(() => {
      this.removeToast(id);
    }, toast.duration || 4000);

    this.timeouts.set(id, timeout);
  }

  removeToast(id: string) {
    this.toasts.set(this.toasts().filter(t => t.id !== id));
    const timeout = this.timeouts.get(id);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(id);
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✗';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '•';
    }
  }
}
